export default "__VITE_ASSET__DgQXKTK5__"